module.exports = {
    schoolApplication: "schoolApplication"
};
